namespace GeniuzPOS.ReportMasterData {
    export interface Report_1505_NForm {
        Year: Serenity.LookupEditor;
        BrandCode: Serenity.StringEditor;
        BrandName: Serenity.StringEditor;
    }

    export class Report_1505_NForm extends Serenity.PrefixedContext {
        static formKey = 'ReportMasterData.Report_1505_N';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!Report_1505_NForm.init)  {
                Report_1505_NForm.init = true;

                var s = Serenity;
                var w0 = s.LookupEditor;
                var w1 = s.StringEditor;

                Q.initFormType(Report_1505_NForm, [
                    'Year', w0,
                    'BrandCode', w1,
                    'BrandName', w1
                ]);
            }
        }
    }
}
